export class filtrosReporteMovimientosDTO {
  codigoAeroplanta: string;
  fechaDesde: Date;
  fechaHasta: Date;
  listaContenedores: string[];
}
